import UTHeader from './components/ut/UTHeader';
import UTHero from './components/ut/UTHero';
import UTFeatureItems from './components/ut/UTFeatureItems';
import UTSpotItems from './components/ut/UTSpotItems';
import UTParallaxItems from './components/ut/UTParallaxItems';

if (document.querySelector('[data-role="ut-page"]')) {
  new UTHeader();
  new UTHero();
  new UTFeatureItems();
  new UTSpotItems();
  new UTParallaxItems();
}
